import React, { useState, useEffect } from "react";
import "./Interview_Guides.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import Common_Banner from "../common/common-banner/Common_Banner";
import { useDispatch, useSelector } from "react-redux";
import { AllInterviewGuide } from "../../features/admin/common/Slice";
import Apply_Modal from "../apply-modal/Apply_Modal";
import { IDS } from "../../utils/IDS";

const Interview_Guides = () => {
  const [show, setShow] = useState(false);
  // const materials = [
  //   {
  //     img: "/assets/images/interview_guides/img-1.png",
  //     category: "Machine Learning",
  //     type: "Study Material",
  //     title: "Supervised Learning Fundamentals",
  //   },
  //   {
  //     img: "/assets/images/interview_guides/img-2.png",
  //     category: "Python",
  //     type: "Study Material",
  //     title: "Python and Its Libraries",
  //   },
  //   {
  //     img: "/assets/images/interview_guides/img-3.png",
  //     category: "GenAI",
  //     type: "Study Material",
  //     title: "Python and Its Libraries",
  //   },
  //   {
  //     img: "/assets/images/interview_guides/img-4.png",
  //     category: "Machine Learning",
  //     type: "Study Material",
  //     title: "Machine Learning Fundamentals",
  //   },
  //   {
  //     img: "/assets/images/interview_guides/img-1.png",
  //     category: "Machine Learning",
  //     type: "Study Material",
  //     title: "Supervised Learning Fundamentals",
  //   },
  //   {
  //     img: "/assets/images/interview_guides/img-2.png",
  //     category: "Python",
  //     type: "Study Material",
  //     title: "Python and Its Libraries",
  //   },
  //   {
  //     img: "/assets/images/interview_guides/img-3.png",
  //     category: "GenAI",
  //     type: "Study Material",
  //     title: "Python and Its Libraries",
  //   },
  //   {
  //     img: "/assets/images/interview_guides/img-4.png",
  //     category: "Machine Learning",
  //     type: "Study Material",
  //     title: "Machine Learning Fundamentals",
  //   },
  // ];

  // const categories = [
  //   { value: "All", label: "All" },
  //   { value: "Machine Learning", label: "Machine Learning" },
  //   { value: "Python", label: "Python" },
  //   { value: "GenAI", label: "GenAI" },
  // ];

  const dispatch = useDispatch();
  const interview_guide = useSelector(
    (state) => state.common.all_interview_guide,
  );

  useEffect(() => {
    dispatch(AllInterviewGuide());
  }, [dispatch]);

  const categories = [
    { value: "All", label: "All" },
    ...[...new Set(interview_guide.map((item) => item.subject))].map(
      (subject) => ({
        value: subject,
        label: subject,
      }),
    ),
  ];

  const [selectedCategory, setSelectedCategory] = useState({
    value: "All",
    label: "All",
  });

  const filteredData =
    selectedCategory?.value && selectedCategory.value !== "All"
      ? interview_guide.filter(
          (item) => item.subject === selectedCategory.value,
        )
      : interview_guide;

  return (
    <section className="Interview_Guides">
      <Common_Banner title="Interview Guides" />

      <div className="container">
        <div className="Interview_Guides_content_div">
          <div className="Interview_Guides_header">
            <h5>
              {" "}
              Interview Prep Guides <span>
                {" "}
                To Level Up Your Tech Career
              </span>{" "}
            </h5>
          </div>

          <div className="study_materials">
            <div className="category_btn_holder">
              <Select
                options={categories}
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e)}
                className="category_btn"
                classNamePrefix="category_btn"
                placeholder="Categories"
                isSearchable={false}
              />
            </div>

            <div className="row">
              {filteredData.map((item, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-5">
                  <div className="material_card_div">
                    <div className="material_card">
                      <div className="card_image_div">
                        <img
                          src={`${IDS.IMG_URL}${item.image}`}
                          alt={item.title}
                          className="card_img"
                        />
                      </div>

                      <div className="card_content">
                        <p className="card_category">
                          {item.subject} • {item.type}
                        </p>
                        <h5 className="card_title">{item.title}</h5>
                      </div>
                    </div>

                    <div className="card_buttons">
                      <button
                        className="buy_btn"
                        onClick={() => window.open(item.link, "_blank")}
                      >
                        Buy Online{" "}
                      </button>

                      <button
                        className="ebook_btn"
                        onClick={() => setShow(true)}
                      >
                        Unlock free ebook
                      </button>

                      <Apply_Modal
                        show={show}
                        handleClose={() => setShow(false)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Interview_Guides;